import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'
import { DEFAULT_ICON_COLOR } from '../constants/icon-consts'

export const CheckIcon = (props?: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={DEFAULT_ICON_COLOR}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path d="M19.4697 5.46967C19.7626 5.17678 20.2374 5.17678 20.5303 5.46967C20.8232 5.76256 20.8232 6.23732 20.5303 6.53022L9.53028 17.5302C9.23738 17.8231 8.76262 17.8231 8.46973 17.5302L3.46973 12.5302C3.17684 12.2373 3.17684 11.7626 3.46973 11.4697C3.76262 11.1768 4.23738 11.1768 4.53028 11.4697L9 15.9394L19.4697 5.46967Z" />
    </svg>
  )
}
